import moment from "moment";

// Must match StockWasteDetail::WASTE_TYPES on the backend.
export const WASTE_TYPES = [
  "expired",
  "spoiled",
  "damaged",
  "prep_error",
  "wrong_usage",
  "over_portion",
  "loss",
  "other",
];

export const WASTE_STATUSES = ["pending", "approved", "rejected", "cancelled"];

export const WASTE_MAX_IMAGES = 10;
export const WASTE_MAX_IMAGE_MB = 5;
export const WASTE_IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];

/**
 * Formatting helpers shared by the waste create page, the request list and the
 * detail dialog. Kept separate from the global main mixin because they only
 * make sense for these three files.
 */
export const wasteMixin = {
  computed: {
    wasteTypeItems() {
      return WASTE_TYPES.map((value) => ({
        value,
        text: this.$t(`waste_type_${value}`),
      }));
    },
  },

  methods: {
    // Decimal-safe number formatting (the global formatNumber() only inserts
    // thousands separators and mangles long decimals).
    wasteNumber(value, digits = 2) {
      const n = Number(value);
      if (!Number.isFinite(n)) return "0";
      return n.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      });
    },

    wasteDate(value, withTime = true) {
      if (!value) return "—";
      const m = moment(value);
      return m.isValid()
        ? m.format(withTime ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY")
        : "—";
    },

    wasteUserName(user) {
      if (!user) return "—";
      const name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      return name || "—";
    },

    wasteImageSrc(path) {
      return window.Help.img(path);
    },

    wasteTypeLabel(type) {
      return type ? this.$t(`waste_type_${type}`) : "—";
    },

    // Whole-number-only quantities: products, variants and recipe menus.
    // Raw ingredients are the only line type that may carry decimals.
    wasteIsWhole(value) {
      return Math.abs(Number(value) - Math.round(Number(value))) < 0.0005;
    },
  },
};
